import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { toText, printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";
import { LoadState$2, SaveStatus as SaveStatus_1, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { NumberDirectoryDTO_GetId_ZC91B2B1, NumberDirectoryDTO$reflection } from "./Model.js";
import { InvoiceeDetails$reflection } from "../Invoicee/Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { RadioInput, RadioInput_get_getDefault, inputRadio } from "../../Components/FormFields/FormFields.js";
import { uncurry, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getWrappedMaterialIcon, dotsLoading, bouncingBox, getMaterialIcon } from "../../ViewUtils.js";
import { logwi, DateTimeExtensions_toDateHHmmss, Locale$reflection, delayAsync, optToStr, stackClasses, classNames } from "../../Utils.js";
import { tryFind, filter, map, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadNumberDirectoryDetails, saveContractConsent } from "./Api.js";
import { error, warning } from "../../Components/Message/Message.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { CustomContentAreaTableProps, renderCustomContentAreaTable, Elements_renderCell, renderCell, renderHeader } from "../../Components/Table/Table.js";
import { map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import "../../../src/Containers/NumberDirectory/View.scss";


class SendInfo extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "All", "NameOnly", "AddressOnly", "Unknown"];
    }
}

function SendInfo$reflection() {
    return union_type("Containers.NumberDirectory.View.SendInfo", [], SendInfo, () => [[], [], [], [], []]);
}

function SendInfo_get_NothingStr() {
    return "Nothing";
}

function SendInfo_get_AllStr() {
    return "All";
}

function SendInfo_get_NameOnlyStr() {
    return "Name";
}

function SendInfo_get_AddressOnlyStr() {
    return "Address";
}

function SendInfo_get_UnknownStr() {
    return "Unknown";
}

function SendInfo_OfString(strOpt, clientSettingsDefaultSendInfo) {
    const toSendInfo = (str) => {
        switch (str) {
            case SendInfo_get_NothingStr(): {
                return new SendInfo(0);
            }
            case SendInfo_get_AllStr(): {
                return new SendInfo(1);
            }
            case SendInfo_get_NameOnlyStr(): {
                return new SendInfo(2);
            }
            case SendInfo_get_AddressOnlyStr(): {
                return new SendInfo(3);
            }
            default: {
                return toFail(printf("[SendInfo.OfString] Cannot parse \u0027%s\u0027 into SendInfo."))(str);
            }
        }
    };
    if (strOpt != null) {
        return toSendInfo(strOpt);
    }
    else {
        return toSendInfo(clientSettingsDefaultSendInfo);
    }
}

function SendInfo_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? SendInfo_get_AllStr() : ((_arg.tag === 2) ? SendInfo_get_NameOnlyStr() : ((_arg.tag === 3) ? SendInfo_get_AddressOnlyStr() : ((_arg.tag === 4) ? SendInfo_get_UnknownStr() : SendInfo_get_NothingStr()))));
}

function SendInfo_ToTranslation(getTranslation, si) {
    switch (si.tag) {
        case 1: {
            return getTranslation("CustomerContract.Invoicee.NumberDirectory.All");
        }
        case 2: {
            return getTranslation("CustomerContract.Invoicee.NumberDirectory.NameOnly");
        }
        case 3: {
            return getTranslation("CustomerContract.Invoicee.NumberDirectory.AddressOnly");
        }
        case 4: {
            return getTranslation("Common.Unknown");
        }
        default: {
            return getTranslation("Common.Nothing");
        }
    }
}

class UserChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["InvoiceeData", "EndUserData"];
    }
}

function UserChoice$reflection() {
    return union_type("Containers.NumberDirectory.View.UserChoice", [], UserChoice, () => [[], []]);
}

function UserChoice_FromSettings(clientSettingAlwaysSendEndUserData, contractEndUserOpt) {
    if (clientSettingAlwaysSendEndUserData) {
        if (contractEndUserOpt != null) {
            return new UserChoice(1);
        }
        else {
            return new UserChoice(0);
        }
    }
    else if (contractEndUserOpt == null) {
        return new UserChoice(0);
    }
    else {
        const matchValue_1 = contractEndUserOpt.OnlyInvoiceeData;
        if (matchValue_1 == null) {
            return new UserChoice(1);
        }
        else if (matchValue_1) {
            return new UserChoice(0);
        }
        else {
            return new UserChoice(1);
        }
    }
}

function UserChoice_ToOnlyInvoiceeData_Z15CE73BE(uc) {
    if (uc.tag === 1) {
        return false;
    }
    else {
        return true;
    }
}

class ExpandableAreaProps extends Record {
    constructor(GlobalDependencies, NumberDirectoryDTO, InvoiceeDetails, ReloadNumberDirectoryFn) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.NumberDirectoryDTO = NumberDirectoryDTO;
        this.InvoiceeDetails = InvoiceeDetails;
        this.ReloadNumberDirectoryFn = ReloadNumberDirectoryFn;
    }
}

function ExpandableAreaProps$reflection() {
    return record_type("Containers.NumberDirectory.View.ExpandableAreaProps", [], ExpandableAreaProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["NumberDirectoryDTO", NumberDirectoryDTO$reflection()], ["InvoiceeDetails", InvoiceeDetails$reflection()], ["ReloadNumberDirectoryFn", lambda_type(unit_type, unit_type)]]);
}

const renderExpandableArea = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, inputRecord_1, inputRecord_2, inputRecord_3, arg_11, arg_10, arg_9, children_33;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    let sendInfoState;
    const arg_2 = SendInfo_OfString(props.NumberDirectoryDTO.SendInfo, props.GlobalDependencies.ClientConfig.TelecomNumberDirectoryConsent);
    sendInfoState = react.useState(arg_2);
    const numberDirectorySaveState = react.useState(new SaveStatus_1(0));
    const userChoiceFromSettings = UserChoice_FromSettings(props.GlobalDependencies.ClientConfig.TelecomNumberDirectoryAlwaysSendEndUserData, props.NumberDirectoryDTO.ContractEndUser);
    const userChoiceState = react.useState(userChoiceFromSettings);
    const canChooseBetweenInvoiceeAndEndUser = props.GlobalDependencies.ClientConfig.TelecomNumberDirectoryAlwaysSendEndUserData ? false : (props.NumberDirectoryDTO.ContractEndUser != null);
    let sendInfoChoiceHtml;
    const sendInfoRadioGroupName = "send-info-radio-group";
    const children = [inputRadio((inputRecord = RadioInput_get_getDefault(), new RadioInput("number-directory-send-info-radio-name-address", sendInfoRadioGroupName, (_arg_2) => {
        sendInfoState[1](new SendInfo(1));
    }, inputRecord.RadioValue, getTranslation("CustomerContract.Invoicee.NumberDirectory.All"), equals(sendInfoState[0], new SendInfo(1)), inputRecord.Disabled))), inputRadio((inputRecord_1 = RadioInput_get_getDefault(), new RadioInput("number-directory-send-info-radio-name-only", sendInfoRadioGroupName, (_arg_3) => {
        sendInfoState[1](new SendInfo(2));
    }, inputRecord_1.RadioValue, getTranslation("CustomerContract.Invoicee.NumberDirectory.NameOnly"), equals(sendInfoState[0], new SendInfo(2)), inputRecord_1.Disabled))), inputRadio((inputRecord_2 = RadioInput_get_getDefault(), new RadioInput("number-directory-send-info-radio-address-only", sendInfoRadioGroupName, (_arg_4) => {
        sendInfoState[1](new SendInfo(3));
    }, inputRecord_2.RadioValue, getTranslation("CustomerContract.Invoicee.NumberDirectory.AddressOnly"), equals(sendInfoState[0], new SendInfo(3)), inputRecord_2.Disabled))), inputRadio((inputRecord_3 = RadioInput_get_getDefault(), new RadioInput("number-directory-send-info-radio-nothing", sendInfoRadioGroupName, (_arg_5) => {
        sendInfoState[1](new SendInfo(0));
    }, inputRecord_3.RadioValue, getTranslation("Common.Nothing"), equals(sendInfoState[0], new SendInfo(0)), inputRecord_3.Disabled)))];
    sendInfoChoiceHtml = react.createElement("div", {}, ...children);
    const renderNameAddressBox = (isActive, header, name, street, zipCode, city, userChoice, userChoiceFromSettings_1) => {
        let matchValue_1, arg_6, props_8, props_13, children_18, children_14, children_26, children_20, children_24;
        let checkCircleHtml;
        const circleHtml = getMaterialIcon((matchValue_1 = [isActive, canChooseBetweenInvoiceeAndEndUser], matchValue_1[0] ? "check_circle" : (matchValue_1[1] ? "circle" : "pause_circle")));
        const classes = classNames(ofArray([["box__circle-icon", true], ["box__circle-icon--green", isActive], ["box__circle-icon--white", (!isActive) && canChooseBetweenInvoiceeAndEndUser]]));
        checkCircleHtml = react.createElement("div", {
            className: classes,
        }, circleHtml);
        let headerHtml;
        let currentChoiceHtml;
        const matchValue_2 = equals(userChoice, userChoiceFromSettings_1);
        if (matchValue_2) {
            const children_5 = [(arg_6 = getTranslation("CustomerContract.Invoicee.NumberDirectory.CurrentChoice"), toText(printf("(%s)"))(arg_6))];
            currentChoiceHtml = react.createElement("span", {
                className: "box__header--red",
            }, ...children_5);
        }
        else {
            currentChoiceHtml = react.createElement(react.Fragment, {});
        }
        const children_9 = [(props_8 = [new HTMLAttr(65, stackClasses(ofArray(["font-weight-bold", "ml-3", "mr-1"])))], react.createElement("span", keyValueList(props_8, 1), header)), currentChoiceHtml];
        headerHtml = react.createElement("div", {}, ...children_9);
        const sendInfoHtml = isActive ? sendInfoChoiceHtml : react.createElement(react.Fragment, {});
        const boxClasses = classNames(ofArray([["choices__box", true], ["choices__box--bg-green", isActive]]));
        const children_28 = [(props_13 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))], react.createElement("div", keyValueList(props_13, 1), checkCircleHtml, headerHtml)), (children_18 = [(children_14 = [getTranslation("Common.Name")], react.createElement("div", {
            className: "box__heading",
        }, ...children_14)), react.createElement("div", {}, name)], react.createElement("div", {}, ...children_18)), (children_26 = [(children_20 = [getTranslation("Common.Address")], react.createElement("div", {
            className: "box__heading",
        }, ...children_20)), react.createElement("div", {}, street), (children_24 = [toText(printf("%s %s"))(zipCode)(city)], react.createElement("div", {}, ...children_24))], react.createElement("div", {}, ...children_26)), sendInfoHtml];
        return react.createElement("div", {
            className: boxClasses,
            onClick: (_arg_6) => {
                if (canChooseBetweenInvoiceeAndEndUser) {
                    userChoiceState[1](userChoice);
                }
            },
        }, ...children_28);
    };
    let invoiceeBoxHtml;
    let patternInput;
    const matchValue_3 = props.InvoiceeDetails.Address;
    if (matchValue_3 != null) {
        const address = matchValue_3;
        patternInput = [address.PostalAddress, address.PostalCode, address.PostalCity];
    }
    else {
        patternInput = ["", "", ""];
    }
    invoiceeBoxHtml = renderNameAddressBox(equals(userChoiceState[0], new UserChoice(0)), getTranslation("Common.Customer"), props.InvoiceeDetails.Name, patternInput[0], patternInput[1], patternInput[2], new UserChoice(0), userChoiceFromSettings);
    let endUserBoxHtml;
    let patternInput_1;
    const matchValue_4 = props.NumberDirectoryDTO.ContractEndUser;
    if (matchValue_4 != null) {
        const endUser = matchValue_4;
        patternInput_1 = [(arg_11 = optToStr(endUser.LastName), (arg_10 = optToStr(endUser.MiddleName), (arg_9 = optToStr(endUser.FirstName), toText(printf("%s %s %s"))(arg_9)(arg_10)(arg_11)))), optToStr(endUser.PostalStreetAddress), optToStr(endUser.PostalCode), optToStr(endUser.PostalCity)];
    }
    else {
        patternInput_1 = ["", "", "", ""];
    }
    endUserBoxHtml = renderNameAddressBox(equals(userChoiceState[0], new UserChoice(1)), getTranslation("Common.EndUser"), patternInput_1[0], patternInput_1[1], patternInput_1[2], patternInput_1[3], new UserChoice(1), userChoiceFromSettings);
    let saveButtonHtml;
    const buttonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.Save"), defaultProps.Content, (_arg_13) => {
        let a, sendInfo;
        startImmediate((a = ((sendInfo = (sendInfoState[0]), (numberDirectorySaveState[1](new SaveStatus_1(1)), singleton.Delay(() => singleton.Bind(saveContractConsent(props.GlobalDependencies.ClientNr, props.NumberDirectoryDTO.ContractNr, SendInfo_get_ToString()(sendInfo), UserChoice_ToOnlyInvoiceeData_Z15CE73BE(userChoiceState[0])), (_arg) => {
            const result = _arg;
            const arg_5 = (result.tag === 0) ? (new SaveStatus_1(2)) : (new SaveStatus_1(3, result.fields[0]));
            numberDirectorySaveState[1](arg_5);
            return singleton.Bind(delayAsync(2000, () => {
                numberDirectorySaveState[1](new SaveStatus_1(0));
            }), () => singleton.Return(""));
        }))))), singleton.Delay(() => singleton.Bind(a, (_arg_15) => singleton.Return(props.ReloadNumberDirectoryFn())))));
    }, equals(sendInfoState[0], new SendInfo(4)), "number-directory-save-btn", numberDirectorySaveState[0], defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
    saveButtonHtml = (equals(userChoiceFromSettings, userChoiceState[0]) ? buttonHtml : bouncingBox(buttonHtml));
    const unsavedChangesMessageHtml = equals(userChoiceFromSettings, userChoiceState[0]) ? react.createElement(react.Fragment, {}) : warning(getTranslation("CustomerContract.Invoicee.NumberDirectory.YouHaveUnsavedChanges").split(""));
    const children_35 = [(children_33 = [invoiceeBoxHtml, endUserBoxHtml, react.createElement("div", {
        className: "choices__other",
    }, unsavedChangesMessageHtml, saveButtonHtml)], react.createElement("div", {
        className: "expand-area__choices",
    }, ...children_33))];
    return react.createElement("div", {
        className: "number-directory__expand-area",
    }, ...children_35);
}, void 0, uncurry(2, void 0), void 0, "renderExpandableArea", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\NumberDirectory\\View.fs", 329);

export class NumberDirectoryProps extends Record {
    constructor(Locale, InvoiceeDetails, GlobalDependencies) {
        super();
        this.Locale = Locale;
        this.InvoiceeDetails = InvoiceeDetails;
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function NumberDirectoryProps$reflection() {
    return record_type("Containers.NumberDirectory.View.NumberDirectoryProps", [], NumberDirectoryProps, () => [["Locale", Locale$reflection()], ["InvoiceeDetails", InvoiceeDetails$reflection()], ["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const render = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_1, children, matchValue_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const numberDirectoriesState = react.useState(new LoadState$2(0));
    const activeRowIdState = react.useState(void 0);
    const searchFilterState = react.useState("");
    const loadNumberDirectoryDTOs = () => {
        numberDirectoriesState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadNumberDirectoryDetails(props.GlobalDependencies.ClientNr, props.InvoiceeDetails.InvoiceeNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            numberDirectoriesState[1](arg);
            return singleton.Zero();
        })));
    };
    react.useEffect(loadNumberDirectoryDTOs, [props.GlobalDependencies]);
    let searchBoxHtml;
    const children_2 = [(props_1 = [new HTMLAttr(65, "search__input"), new HTMLAttr(128, getTranslation("CustomerContract.Invoicee.NumberDirectory.SearchNumber")), ["data-translation", "CustomerContract.Invoicee.NumberDirectory.SearchNumber"], new HTMLAttr(99, "number-directory-search-input"), new DOMAttr(9, (event) => {
        searchFilterState[1](Browser_Types_Event__Event_get_Value(event));
    })], react.createElement("input", keyValueList(props_1, 1))), (children = [getMaterialIcon("search")], react.createElement("div", {
        className: "search__icon",
    }, ...children))];
    searchBoxHtml = react.createElement("div", {
        className: "number-directory__search",
    }, ...children_2);
    let tableHtml;
    const matchValue = numberDirectoriesState[0];
    switch (matchValue.tag) {
        case 1: {
            tableHtml = dotsLoading;
            break;
        }
        case 3: {
            tableHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            const numberDirectoryDTOs = matchValue.fields[0];
            const headers = ofArray([renderHeader(getTranslation("Common.Number")), renderHeader(getTranslation("Common.Status")), renderHeader(getTranslation("Common.Saved")), renderHeader(getTranslation("Common.Sent")), renderHeader("")]);
            const rows = map((dto) => {
                let chevronHtml;
                let materialIconStr;
                const matchValue_1 = equals(activeRowIdState[0], NumberDirectoryDTO_GetId_ZC91B2B1(dto));
                materialIconStr = (matchValue_1 ? "expand_less" : "expand_more");
                const props_8 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-end", "pointer"])))];
                const children_5 = [getMaterialIcon(materialIconStr)];
                chevronHtml = react.createElement("div", keyValueList(props_8, 1), ...children_5);
                let visibilityStatusHtml;
                const sendInfo = SendInfo_OfString(dto.SendInfo, props.GlobalDependencies.ClientConfig.TelecomNumberDirectoryConsent);
                const iconHtml = getWrappedMaterialIcon((sendInfo.tag === 4) ? "help" : ((sendInfo.tag === 0) ? "visibility_off" : "visibility"));
                let textHtml;
                const children_7 = [SendInfo_ToTranslation(getTranslation, sendInfo)];
                textHtml = react.createElement("div", {
                    className: "mr-2",
                }, ...children_7);
                const props_12 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "justify-content-center"])))];
                visibilityStatusHtml = react.createElement("div", keyValueList(props_12, 1), textHtml, iconHtml);
                return [ofArray([renderCell(dto.Number), Elements_renderCell(visibilityStatusHtml), renderCell(defaultArg(map_1((arg_7) => DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, parse(arg_7)), dto.CreatedAtUtc), "")), renderCell(defaultArg(map_1((arg_9) => DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, parse(arg_9)), dto.SentAtUtcDirService), "")), Elements_renderCell(chevronHtml)]), NumberDirectoryDTO_GetId_ZC91B2B1(dto)];
            }, (matchValue_2 = (searchFilterState[0]).trim(), (matchValue_2 === "") ? numberDirectoryDTOs : filter((dto_1) => (dto_1.Number.indexOf(matchValue_2) === 0), numberDirectoryDTOs)));
            tableHtml = Pagination()(new PageinationProps$1((rows_1) => renderCustomContentAreaTable(new CustomContentAreaTableProps(headers, rows_1, (rowId) => {
                const matchValue_3 = tryFind((dto_2) => (NumberDirectoryDTO_GetId_ZC91B2B1(dto_2) === rowId), numberDirectoryDTOs);
                if (matchValue_3 != null) {
                    return renderExpandableArea(new ExpandableAreaProps(props.GlobalDependencies, matchValue_3, props.InvoiceeDetails, loadNumberDirectoryDTOs));
                }
                else {
                    logwi(toText(printf("[renderExpandableAreaFn] Cannot find id: %s"))(rowId));
                    return void 0;
                }
            }, activeRowIdState)), rows, 10, 0));
            break;
        }
        default: {
            tableHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_13 = [react.createElement("div", {
        className: "number-directory__container-vertical",
    }, searchBoxHtml, tableHtml)];
    return react.createElement("div", {
        className: "number-directory",
    }, ...children_13);
}, void 0, uncurry(2, void 0), void 0, "render", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\NumberDirectory\\View.fs", 486);

